import { useState } from 'react'
import { useIntl } from 'react-intl'
import { WrapperProps } from '../../../../components'
import { createContextFactory } from '../../../../contexts/utils'
import { MembershipFeesQueryType } from '../../../../types'
import { UserInfo } from '../../../../utils/classes/graphql'
import {
  CalculateMembershipFeeInput,
  PaymentInfoData,
  PaymentInfoType
} from '../types'
import { createPaymentInfo } from './utils'

const [usePaymentInfo, PaymentInfoContextProvider] =
  createContextFactory<PaymentInfoData>(
    'usePaymentInfo',
    'PaymentInfoContextProvider'
  )

const PaymentInfoProvider = ({ children }: WrapperProps) => {
  const [paymentInfo, setPaymentInfo] = useState<PaymentInfoType>()

  const { formatMessage } = useIntl()

  const updatePaymentInfo = (
    bankAccounts: MembershipFeesQueryType['bankAccounts'],
    user: UserInfo,
    values: CalculateMembershipFeeInput
  ) => {
    const { error, paymentInfo } = createPaymentInfo(
      bankAccounts,
      user,
      values,
      formatMessage
    )

    setPaymentInfo(paymentInfo)

    return error
  }

  return (
    <PaymentInfoContextProvider
      value={{
        paymentInfo,
        updatePaymentInfo
      }}
    >
      {children}
    </PaymentInfoContextProvider>
  )
}

export { PaymentInfoProvider, usePaymentInfo }
